import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changeAuth } from "../actions/loginAction";
import {
  Chip,
  Stack,
  Avatar,
  Switch,
  TextField,
  DialogActions,
  Modal,
  Box,
  Stepper,
  IconButton,
  Typography,
  StepLabel,
  Step,
  Button,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  OutlinedInput,
  InputAdornment,
  LinearProgress,
  TableCell,
  Menu,
  TableHead,
  TableContainer,
  Table,
  TableRow,
  Checkbox,
  TableBody,
  Tooltip,
  TablePagination,
  MenuItem,
  Select,
  InputLabel,
  Zoom,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import pdffile from "../assets/images/pdf-file.svg";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CircularProgressloader from "../components/loader/CircularProgress";
import MessageSnackbar from "../_layout/elements/snackbar";
import host from "../host";
import * as mammoth from "mammoth";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { pdfjs } from "react-pdf";
import docicon from "../assets/images/docx.jpg";
import excelicon from "../assets/images/excel.jpg";
import websiteIcon from "../assets/images/type_website.png";
import filetype from "../assets/images/type_file.png";
import filewebsite from "../assets/images/type_website.png";
import filePostgres from "../assets/images/type_Postgres.png";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const steps = ["Folder Details", "Files"];
export default function AddBrain(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [brainName, setBrainName] = useState("");
  const [brainDescription, setbrainDescription] = useState("");
  const [isPublic, setIsPublic] = useState("");
  const [fileLoading, setFileLoading] = useState(false);
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [url, setUrl] = useState("");
  const [dbUser, setDbUser] = useState("");
  const [dbPassword, setDbPassword] = useState("");
  const [dbHost, setDbHost] = useState("");
  const [dbPort, setDbPort] = useState("");
  const [dbName, setDbName] = useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const isStepOptional = (step) => {
    return step === 0;
  };
  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
  const handleNext = () => {
    if (activeStep === 0 && !brainName.trim()) {
      setSeverity("error");
      setMessage("Folder name cannot be empty");
      setSnackbar(true);
      return;
    }

    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  //document icon display logic start
  const getIcon = (fileName, doc_type) => {
    if (doc_type === "url") {
      return websiteIcon;
    } else if (doc_type === null) {
      const fileParts = fileName?.split(".");
      const fileExtension = fileParts[fileParts?.length - 1];
      if (fileExtension === "pdf") {
        return pdffile;
      } else if (fileExtension === "docx") {
        return docicon;
      } else if (fileExtension === "xlsx") {
        return excelicon;
      } else {
        return pdffile;
      }
    } else {
      return pdffile;
    }
  };
  //document icon display logic end

  // upload knowledge functionality begins

  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileInputRef = useRef(null);
  const MAX_FILE_SIZE = 32 * 1024 * 1024; // size limit for file in future

  const [activeLink, setActiveLink] = useState("option1"); // default active link
  const [progresstype, setProgresstype] = useState(0); // default progress value

  const handleLinkClick = (option) => {
    setActiveLink(option);
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    const newSelectedFiles = Array.from(files).filter((file) => {
      if (file.size > MAX_FILE_SIZE) {
        setSeverity("error");
        setMessage("Please upload file with less than 32MB");
        setSnackbar(true);
        return false;
      }
      return true;
    });
    setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, ...newSelectedFiles]);
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    const newSelectedFiles = Array.from(files).filter((file) => {
      if (file.size > MAX_FILE_SIZE) {
        setSeverity("error");
        setMessage("Please upload file with less than 32MB");
        setSnackbar(true);
        return false;
      }
      return true;
    });
    setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, ...newSelectedFiles]);
  };

  const handleDrag = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (fileToDelete) => {
    setSelectedFiles(selectedFiles.filter((file) => file !== fileToDelete));
  };

  function dataURItoBlob(dataURI) {
    // Convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0) byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // Separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // Write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }
  const [brainList1, setBrainList1] = useState([]);

  const getbrains = () => {
    fetch(host.chaturl + `/brain`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          localStorage.clear();
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setBrainList1(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [uploadedBrainId, setUploadedBrainId] = useState(null);
  useEffect(() => {
    if (brainList1 && brainList1.length > 0 && uploadedBrainId) {
      const newBrain = brainList1.find((brain) => brain.id === uploadedBrainId);
      props.setSelectedbrain(newBrain);
      props.setBrainList(brainList1);
    }
  }, [brainList1, uploadedBrainId]);

  const handleUpload = (option) => {
    if (option === "option1") {
      if (!selectedFiles[0]) {
        setSeverity("error");
        setMessage("Please upload file");
        setSnackbar(true);
        return;
      }
      setFileLoading(true);
      const formData = new FormData();
      formData.append("file", selectedFiles[0]);

      const reader = new FileReader();
      reader.onload = function (event) {
        if (selectedFiles[0].type === "application/pdf") {
          const pdfData = new Uint8Array(event.target.result);
          pdfjs.getDocument({ data: pdfData }).promise.then(function (pdf) {
            pdf.getPage(1).then(function (page) {
              const viewport = page.getViewport({ scale: 1 });
              const canvas = document.createElement("canvas");
              const context = canvas.getContext("2d");
              canvas.height = viewport.height;
              canvas.width = viewport.width;

              const renderContext = {
                canvasContext: context,
                viewport: viewport,
              };
              page.render(renderContext).promise.then(function () {
                canvas.toBlob(function (blob) {
                  const thumbnailFile = new File([blob], "thumbnail.png", { type: blob.type });
                  formData.append("thumbnail", thumbnailFile); // Append the thumbnail image
                  let status = isPublic ? "public" : "private";
                  return fetch(host.chaturl + `/brain`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                    body: JSON.stringify({
                      name: brainName,
                      description: brainDescription,
                      status: status,
                    }),
                  })
                    .then((res) => {
                      if (res.ok) {
                        return res.json();
                      } else if (res.status === 403) {
                        dispatch(changeAuth(false, null));
                        navigate("/logout");
                      } else {
                        setFileLoading(false);
                        setSeverity("error");
                        setMessage("Something went wrong");
                        setSnackbar(true);
                      }
                    })
                    .then((data) => {
                      if (data) {
                        getbrains();
                        fetch(host.chaturl + `/brain/upload/${data.brain_id}`, {
                          method: "POST",
                          headers: {
                            Authorization: "Bearer " + localStorage.getItem("token"),
                          },
                          body: formData,
                        })
                          .then((res) => {
                            if (res.ok) {
                              return res.json();
                            } else if (res.status === 403) {
                              dispatch(changeAuth(false, null));
                              navigate("/logout");
                            } else {
                              setFileLoading(false);
                              setSeverity("error");
                              setMessage("Something went wrong");
                              setSnackbar(true);
                            }
                          })
                          .then((data) => {
                            setFileLoading(false);
                            handleNext();
                            setSelectedFiles([]);
                            setUploadedBrainId(data?.brain?._id);
                          })
                          .catch((error) => {
                            console.error("Error uploading file:", error);
                            setFileLoading(false);
                          });
                      }
                    })
                    .catch((error) => {
                      console.error("Error uploading file:", error);
                      setFileLoading(false);
                    });
                });
              });
            });
          });
        } else if (selectedFiles[0].type === "application/msword" || selectedFiles[0].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
          const reader = new FileReader();
          reader.onload = function (event) {
            mammoth
              .convertToHtml({ arrayBuffer: event.target.result })
              .then(function (result) {
                const html = result.value; // The generated HTML
                const messages = result.messages; // Any messages, such as warnings during conversion

                // Create a new off-screen div to hold the HTML
                const div1 = document.createElement("div");
                // div1.style.visibility = 'hidden';
                div1.innerHTML = html;

                // Append the div to the body
                document.body.appendChild(div1);

                // Use html2canvas to take a snapshot of the div
                html2canvas(div1).then(function (canvas) {
                  // Get the Data URL from the canvas
                  const dataUrl = canvas.toDataURL("image/png");

                  // Create a new image file from the Data URL
                  fetch(dataUrl)
                    .then((res) => res.blob())
                    .then((blob) => {
                      const thumbnailFile = new File([blob], "thumbnail.png", { type: blob.type });
                      formData.append("thumbnail", thumbnailFile); // Append the thumbnail image

                      // Remove the div from the body
                      document.body.removeChild(div1);
                      let status = isPublic ? "public" : "private";
                      return fetch(host.chaturl + `/brain`, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                        body: JSON.stringify({
                          name: brainName,
                          description: brainDescription,
                          status: status,
                        }),
                      });
                    })
                    .then((res) => {
                      if (res.ok) {
                        return res.json();
                      } else if (res.status === 403) {
                        dispatch(changeAuth(false, null));
                        navigate("/logout");
                      } else {
                        setFileLoading(false);
                        setSeverity("error");
                        setMessage("Something went wrong");
                        setSnackbar(true);
                      }
                    })
                    .then((data) => {
                      if (data) {
                        getbrains();
                        fetch(host.chaturl + `/brain/upload/${data.brain_id}`, {
                          method: "POST",
                          headers: {
                            Authorization: "Bearer " + localStorage.getItem("token"),
                          },
                          body: formData,
                        })
                          .then((res) => {
                            if (res.ok) {
                              return res.json();
                            } else if (res.status === 403) {
                              dispatch(changeAuth(false, null));
                              navigate("/logout");
                            } else {
                              setFileLoading(false);
                              setSeverity("error");
                              setMessage("Something went wrong");
                              setSnackbar(true);
                            }
                          })
                          .then((data) => {
                            setFileLoading(false);
                            handleNext();
                            setSelectedFiles([]);
                            setUploadedBrainId(data?.brain?._id);
                          })
                          .catch((error) => {
                            console.error("Error uploading file:", error);
                            setFileLoading(false);
                          });
                      }
                    })
                    .catch((error) => {
                      console.error("Error uploading file:", error);
                      setFileLoading(false);
                    });
                });
              })
              .done();
          };
          reader.readAsArrayBuffer(selectedFiles[0]);
        } else if (selectedFiles[0].type === "application/vnd.ms-excel" || selectedFiles[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
          const reader = new FileReader();
          reader.onload = function (event) {
            const workbookData = event.target.result;
            const workbook = XLSX.read(workbookData, { type: "array" });

            // Get the first sheet
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            // Convert the worksheet to HTML
            const html = XLSX.utils.sheet_to_html(worksheet);

            // Create a new off-screen div to hold the HTML
            const div = document.createElement("div");
            //div.style.visibility = 'hidden';
            div.innerHTML = html;

            // Append the div to the body
            document.body.appendChild(div);

            // Use html2canvas to take a snapshot of the div
            html2canvas(div)
              .then((canvas) => {
                // Get the Data URL from the canvas
                const dataUrl = canvas.toDataURL("image/png");

                // Create a blob from the image data
                const blob = dataURItoBlob(dataUrl);

                // Create a File object from the blob
                const thumbnailFile = new File([blob], "thumbnail.png", { type: "image/png" });

                // Append the thumbnail image to formData
                formData.append("thumbnail", thumbnailFile);
                // Remove the div from the body
                document.body.removeChild(div);
                let status = isPublic ? "public" : "private";
                return fetch(host.chaturl + `/brain`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                  },
                  body: JSON.stringify({
                    name: brainName,
                    description: brainDescription,
                    status: status,
                  }),
                });
                // Continue with your existing logic to send the thumbnail to the server
              })
              .then((res) => {
                if (res.ok) {
                  return res.json();
                } else if (res.status === 403) {
                  dispatch(changeAuth(false, null));
                  navigate("/logout");
                } else {
                  setFileLoading(false);
                  setSeverity("error");
                  setMessage("Something went wrong");
                  setSnackbar(true);
                }
              })
              .then((data) => {
                if (data) {
                  getbrains();
                  fetch(host.chaturl + `/brain/upload/${data.brain_id}`, {
                    method: "POST",
                    headers: {
                      Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                    body: formData,
                  })
                    .then((res) => {
                      if (res.ok) {
                        return res.json();
                      } else if (res.status === 403) {
                        dispatch(changeAuth(false, null));
                        navigate("/logout");
                      } else {
                        setFileLoading(false);
                        setSeverity("error");
                        setMessage("Something went wrong");
                        setSnackbar(true);
                      }
                    })
                    .then((data) => {
                      setFileLoading(false);
                      handleNext();
                      setSelectedFiles([]);
                      setUploadedBrainId(data?.brain?._id);
                    })
                    .catch((error) => {
                      console.error("Error uploading file:", error);
                      setFileLoading(false);
                    });
                }
              })
              .catch((error) => {
                console.error("Error uploading file:", error);
                setFileLoading(false);
              });
          };

          reader.readAsArrayBuffer(selectedFiles[0]);
        }
        // } else {
        //   return fetch(pdfImage)
        //     .then((response) => response.blob())
        //     .then((blob) => {
        //       const thumbnailFile = new File([blob], "thumbnail.png", { type: blob.type });
        //       formData.append("thumbnail", thumbnailFile);
        //       let status = isPublic ? "public" : "private";
        //       return fetch(host.chaturl + `/brain`, {
        //         method: "POST",
        //         headers: {
        //           "Content-Type": "application/json",
        //           Authorization: "Bearer " + localStorage.getItem("token"),
        //         },
        //         body: JSON.stringify({
        //           name: brainName,
        //           description: brainDescription,
        //           status: status,
        //         }),
        //       });
        //     })
        //     .then((res) => {
        //       if (res.ok) {
        //         return res.json();
        //       } else if (res.status === 403) {
        //         dispatch(changeAuth(false, null));
        //         navigate("/logout");
        //       } else {
        //         setFileLoading(false);
        //         setSeverity("error");
        //         setMessage("Something went wrong");
        //         setSnackbar(true);
        //       }
        //     })
        //     .then((data) => {
        //       if (data) {
        //         getbrains();
        //         fetch(host.chaturl + `/brain/upload/${data.brain_id}`, {
        //           method: "POST",
        //           headers: {
        //             Authorization: "Bearer " + localStorage.getItem("token"),
        //           },
        //           body: formData,
        //         })
        //           .then((res) => {
        //             if (res.ok) {
        //               return res.json();
        //             } else if (res.status === 403) {
        //               dispatch(changeAuth(false, null));
        //               navigate("/logout");
        //             } else {
        //               setFileLoading(false);
        //               setSeverity("error");
        //               setMessage("Something went wrong");
        //               setSnackbar(true);
        //             }
        //           })
        //           .then((data) => {
        //             setFileLoading(false);
        //             handleNext();
        //             setSelectedFiles([]);
        //             setUploadedBrainId(data?.brain?._id);
        //           })
        //           .catch((error) => {
        //             console.error("Error uploading file:", error);
        //             setFileLoading(false);
        //           });
        //       }
        //     })
        //     .catch((error) => {
        //       console.error("Error uploading file:", error);
        //       setFileLoading(false);
        //     });
        // }
      };
      reader.readAsArrayBuffer(selectedFiles[0]);
    } else if (option === "option3") {
      handleDBUpload();
    }
  };

  // Define the handleWebsiteUrl function
  const handleWebsiteUrl = () => {
    let status = isPublic ? "public" : "private";
    return fetch(host.chaturl + `/brain`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({
        name: brainName,
        description: brainDescription,
        status: status,
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setFileLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          getbrains();
          fetch(host.chaturl + `/brain/upload/url/${data.brain_id}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            body: JSON.stringify({
              url: url,
            }),
          })
            .then((res) => {
              if (res.ok) {
                return res.json();
              } else if (res.status === 403) {
                dispatch(changeAuth(false, null));
                navigate("/logout");
              } else {
                setFileLoading(false);
                setSeverity("error");
                setMessage("Something went wrong");
                setSnackbar(true);
              }
            })
            .then((data) => {
              setFileLoading(false);
              handleNext();
              setSelectedFiles([]);
              setUrl("");
              setUploadedBrainId(data?.brain?._id);
            })
            .catch((error) => {
              console.error("Error uploading file:", error);
              setFileLoading(false);
            });
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        setFileLoading(false);
      });
  };

  //Define the handleDBUpload function
  const handleDBUpload = () => {
    let status = isPublic ? "public" : "private";
    return fetch(host.chaturl + `/brain`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({
        name: brainName,
        description: brainDescription,
        status: status,
        brain_type: "database",
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setFileLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          getbrains();
          fetch(host.chaturl + `/brain/upload/db/${data.brain_id}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            body: JSON.stringify({
              db_user: dbUser,
              db_password: dbPassword,
              db_host: dbHost,
              db_port: dbPort,
              db_name: dbName,
              db_type: "postgres",
            }),
          })
            .then((res) => {
              if (res.ok) {
                return res.json();
              } else if (res.status === 403) {
                dispatch(changeAuth(false, null));
                navigate("/logout");
              } else {
                setFileLoading(false);
                setSeverity("error");
                setMessage("Something went wrong");
                setSnackbar(true);
              }
            })
            .then((data) => {
              setFileLoading(false);
              handleNext();
              setSelectedFiles([]);
              setUrl("");
              setUploadedBrainId(data?.brain?._id);
            })
            .catch((error) => {
              console.error("Error uploading file:", error);
              setFileLoading(false);
            });
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        setFileLoading(false);
      });
  };

  const onClose = () => {
    setSnackbar(false);
  };

  const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(({ theme }) => ({
    width: 38,
    height: 20,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 16,
      height: 16,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  return (
    <>
      <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />
      <Modal open={props.openaddbrain} onClose={props.handleCloseaddbrain} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className=" commonpopup  modal-common   popup-w50 ">
          <div className="card-item__content   ">
            <div class="card-title">
              <h2>Create New Folder</h2>
              <span>Create a new space for your data</span>
            </div>
            <Link
              className="close"
              onClick={() => {
                props.handleCloseaddbrain();
                setActiveStep(0);
                setBrainName("");
                setbrainDescription("");
                setSelectedFiles([]);
              }}
            >
              X
            </Link>
          </div>
          <div className="modal-body">
            <div className="popup_scroller">
              <div className="add_brain-step_wrapper">
                <div className="step_head">
                  <Stepper activeStep={activeStep}>
                    {steps.map((label, index) => {
                      const stepProps = {};
                      const labelProps = {};
                      if (isStepOptional(index)) {
                        labelProps.optional = <Typography variant="caption"> </Typography>;
                      }
                      if (isStepSkipped(index)) {
                        stepProps.completed = false;
                      }
                      return (
                        <Step key={label} {...stepProps}>
                          <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                </div>
                <div className="add_brain_body">
                  {activeStep === steps.length ? (
                    <React.Fragment>
                      <div className="finish-steps" sx={{ mt: 2, mb: 1 }}>
                        <div className="step-successbox">
                          <div className="success-stepicon">
                            <div className="success-checkmark">
                              <div className="check-icon">
                                <span className="icon-line line-tip" />
                                <span className="icon-line line-long" />
                                <div className="icon-circle" />
                                <div className="icon-fix" />
                              </div>
                            </div>

                            {/* <img className=" " src={success} alt="sender-icon" /> */}
                          </div>
                          <div className="success-stepmessage">
                            <h5> Folder created successfully</h5>
                          </div>
                        </div>
                      </div>
                      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                        <Box sx={{ flex: "1 1 auto" }} />
                        <Button
                          onClick={() => {
                            props.handleCloseaddbrain();
                            setActiveStep(0);
                            setBrainName("");
                            setbrainDescription("");
                            setSelectedFiles([]);
                          }}
                        >
                          Ok
                        </Button>
                      </Box>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {/* {activeStep === 0 && (
                      <div className="steps-content">
                        <div className="row">
                          <div className="col-12">
                            <div className="form-group">
                              <label> Library source</label>
                              <FormControl>
                                <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                                  <FormControlLabel value="Documents" control={<Radio checked={true} />} label="Documents" />
                                
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      </div>
                    )} */}
                      {activeStep === 0 && (
                        <div className="steps-content">
                          <div className="row">
                            <div className="col-12">
                              <div className="form-group">
                                <label>
                                  Folder Name <span className="text-danger">*</span>
                                </label>
                                <TextField
                                  id="outlined-basic"
                                  type="text"
                                  placeholder="Enter folder name ( Example : Collection 1 , Collection 2 ,... )"
                                  size="small"
                                  value={brainName}
                                  onChange={(e) => {
                                    setBrainName(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-group">
                                <label>Folder Description </label>
                                <TextField
                                  id="outlined-basic"
                                  type="text"
                                  placeholder="Describe the folder"
                                  multiline
                                  rows={4}
                                  value={brainDescription}
                                  onChange={(e) => {
                                    setbrainDescription(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-group">
                                <label> Folder Access</label>
                                <FormControl>
                                  <RadioGroup aria-label="options" name="options" row>
                                    <div className="radio-text">
                                      <FormControlLabel
                                        value="option1"
                                        control={
                                          <Radio
                                            checked={isPublic}
                                            onClick={() => {
                                              setIsPublic(true);
                                            }}
                                          />
                                        }
                                        label="Public Document"
                                      />
                                      <span className="shortcontent">This folder will be shared with the chatbot community</span>
                                    </div>
                                    <div className="radio-text">
                                      <FormControlLabel
                                        value="option2"
                                        control={
                                          <Radio
                                            checked={!isPublic}
                                            onClick={() => {
                                              setIsPublic(false);
                                            }}
                                          />
                                        }
                                        label="Private Document"
                                      />
                                      <span className="shortcontent">Easily accessible for you and those you share it with</span>
                                    </div>
                                  </RadioGroup>
                                </FormControl>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {activeStep === 1 && (
                        <div className="steps-content">
                          <div className="col-md-12">
                            <div className="whatpdf_wrapper">
                              <div className="file_type_upload_wrapper">
                                <div className="file_type_upload_head">
                                  <div className="form-group">
                                    <label>Upload Type</label>
                                  </div>
                                  <div className="upload_type_items">
                                    <div className="upload_type_items_row">
                                      <Link to="#" value="option1" className={`upload_type_cta ${activeLink === "option1" ? "active" : ""}`} onClick={() => handleLinkClick("option1")}>
                                        <div className="upload_type_icon">
                                          <img src={filetype} alt="" />
                                        </div>
                                        <div className="upload_type_name">File</div>
                                      </Link>

                                      <Link to="#" value="option2" className={`upload_type_cta ${activeLink === "option2" ? "active" : ""}`} onClick={() => handleLinkClick("option2")}>
                                        <div className="upload_type_icon">
                                          <img src={filewebsite} alt="" />
                                        </div>
                                        <div className="upload_type_name">Website</div>
                                      </Link>

                                      <Link to="#" className={`upload_type_cta ${activeLink === "option3" ? "active" : ""}`} onClick={() => handleLinkClick("option3")}>
                                        <div className="upload_type_icon">
                                          <img src={filePostgres} alt="" />
                                        </div>
                                        <div className="upload_type_name">Postgres</div>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                                <div className="file_type_upload_body">
                                  {activeLink === "option1" && (
                                    <>
                                      {selectedFiles.length === 0 && (
                                        <div className="csv-upload " onDrop={handleFileDrop} onDragOver={handleDrag} onDragEnter={handleDrag} onDragLeave={handleDrag}>
                                          <div className="upload-pdf">
                                            <label htmlFor="file-upload1">
                                              <input type="file" id="file-upload1" style={{ visibility: "hidden" }} onChange={handleFileChange} ref={fileInputRef} />
                                              <div className="svg-circle">
                                                <FileUploadOutlinedIcon />
                                              </div>
                                              <h5> Drag and drop files to upload </h5>
                                              <p>PDF, DOCX, DOC or .XLSX (32MB Max)</p>
                                            </label>
                                          </div>
                                        </div>
                                      )}
                                      {selectedFiles.length > 0 && (
                                        <div className="uploaded-item-body">
                                          <div className="uploaded-item-scroll">
                                            {selectedFiles.map((file, index) => (
                                              <div className="uploaded-item-row" key={index}>
                                                <div className="file-row">
                                                  {/* Assuming pdffile is your placeholder image */}
                                                  <img src={getIcon(file.name ? file.name : null, file.doc_type ? file.doc_type : null)} height={25} alt="" />
                                                  <div className="filerowname">{file.name}</div>
                                                </div>
                                                {fileLoading ? (
                                                  <div className="file-status">
                                                    <CircularProgressloader />
                                                  </div>
                                                ) : (
                                                  <div className="delet_file">
                                                    <IconButton aria-label="delete" onClick={() => handleDeleteFile(file)}>
                                                      <DeleteIcon />
                                                    </IconButton>
                                                  </div>
                                                )}
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  )}
                                  {activeLink === "option2" && (
                                    <div className="card">
                                      <div className="card-body">
                                        <div className="upload-other">
                                          <div className="form-group">
                                            <div className="url-search p-0">
                                              <div className="search-url">
                                                <div className="chat_form_flexbox">
                                                  <div className="messageform">
                                                    <TextField
                                                      id="outlined-multiline-flexible"
                                                      placeholder="From URL / https://example.com/file.pdf"
                                                      value={url}
                                                      onChange={(e) => setUrl(e.target.value)} // Update the state when the input changes
                                                    />
                                                  </div>
                                                  <div className="send_btn">
                                                    <Link to="">
                                                      <button type="button" className="senderbtn" onClick={handleWebsiteUrl}>
                                                        <SendOutlinedIcon />
                                                      </button>
                                                    </Link>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {activeLink === "option3" && (
                                    <div className="card">
                                      <div className="card-body">
                                        <div className="database_interface">
                                          <div className="database_interface_head">
                                            <h4>Postgres</h4>
                                          </div>

                                          <div className="row">
                                            <div className="col-md-6">
                                              <div className="form-group">
                                                <label>DB User</label>
                                                <FormControl fullWidth size="small">
                                                  <TextField
                                                    size="small"
                                                    id="outlined-multiline-flexible"
                                                    placeholder="Enter User Name"
                                                    multiline
                                                    value={dbUser}
                                                    onChange={(e) => setDbUser(e.target.value)}
                                                  />
                                                </FormControl>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="form-group">
                                                <label>DB Password</label>
                                                <FormControl fullWidth size="small">
                                                  <OutlinedInput
                                                    size="small"
                                                    placeholder=" DB Password"
                                                    id="standard-adornment-password"
                                                    type={showPassword ? "text" : "password"}
                                                    value={dbPassword}
                                                    onChange={(e) => setDbPassword(e.target.value)}
                                                    endAdornment={
                                                      <InputAdornment position="end">
                                                        <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
                                                          {showPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                      </InputAdornment>
                                                    }
                                                  />
                                                </FormControl>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="form-group">
                                                <label>Host</label>
                                                <FormControl fullWidth size="small">
                                                  <TextField
                                                    size="small"
                                                    id="outlined-multiline-flexible"
                                                    placeholder="Enter Host"
                                                    multiline
                                                    value={dbHost}
                                                    onChange={(e) => setDbHost(e.target.value)}
                                                  />
                                                </FormControl>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="form-group">
                                                <label>Port</label>
                                                <FormControl fullWidth size="small">
                                                  <TextField
                                                    size="small"
                                                    id="outlined-multiline-flexible"
                                                    placeholder="Enter Port"
                                                    multiline
                                                    value={dbPort}
                                                    onChange={(e) => setDbPort(e.target.value)}
                                                  />
                                                </FormControl>
                                              </div>
                                            </div>
                                            <div className="col-md-12">
                                              <div className="form-group">
                                                <label>DB Name</label>
                                                <FormControl fullWidth size="small">
                                                  <TextField
                                                    size="small"
                                                    id="outlined-multiline-flexible"
                                                    placeholder="Enter DB Name"
                                                    multiline
                                                    value={dbName}
                                                    onChange={(e) => setDbName(e.target.value)}
                                                  />
                                                </FormControl>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {activeLink === "option6" && <div>{/* Add content for Slack upload */}</div>}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                        <Button color="inherit" disabled={activeStep === 0 || fileLoading} onClick={handleBack} sx={{ mr: 1 }}>
                          Back
                        </Button>
                        <Box sx={{ flex: "1 1 auto" }} />
                        {/* {isStepOptional(activeStep) && (
                        <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                          Skip
                        </Button>
                      )} */}
                        {(activeStep === 0 || (activeStep === 1 && (activeLink === "option1" || activeLink === "option3"))) && (
                          <Button
                            disabled={fileLoading}
                            onClick={() => {
                              if (activeStep === steps.length - 1) {
                                handleUpload(activeLink);
                              } else {
                                handleNext();
                              }
                            }}
                          >
                            {activeStep === steps.length - 1 ? "Submit" : "Next"}
                          </Button>
                        )}
                      </Box>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
